import ClipboardJS from 'clipboard';

// Give any button or link that copies to clipboard the clipper class.
// Then, use data attributes to set the clip target.
document.addEventListener("turbolinks:load", function() {
  let clipboard = new ClipboardJS('.clipper');
});
